import Vue from "vue";
import Router from "vue-router";

import { getLCP, getFID } from "web-vitals";
import { mainRoutes } from "@/routes";

declare let gtag: any;

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active-ne",
  linkExactActiveClass: "active",
  routes: mainRoutes,
});

/* eslint-disable */
router.afterEach((to, from) => {
  // add 'traffic_type=internal' to exclude developer traffic
  if (process.env.NODE_ENV !== "production") {
    gtag('set', 'traffic_type', 'internal');
  }

  // adds analytics debug if present
  if (to.query.debug) {
    gtag('set', 'debug_mode', true);
  }

  const webVitalsEvent = (args: any) => {
    const { name, delta, id } = args;

    gtag("event", name, {
      event_category: "Web Vitals",
      value: Math.round(name === "CLS" ? delta * 1000 : delta),
      event_label: id,
      non_interaction: true
    });
  };

  // only track web virtals in production
  if (process.env.NODE_ENV == "production") {
    getFID(webVitalsEvent);
    getLCP(webVitalsEvent);
  }
});
/* eslint-enable */

export default router;
